import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { DateTooltipPipe } from '@interacta-shared/util-common';
import { UserNotificationEvent } from '@modules/notification/models/user-notification.model';
import { TaskExpirationDatePipe } from '@modules/shared-v2/pipes/task-expiration-date.pipe';
import { UserNotificationComponent } from '../user-notification/user-notification.component';

@Component({
    selector: 'interacta-task-user-notification',
    imports: [
        UserNotificationComponent,
        MatTooltip,
        DateTooltipPipe,
        TaskExpirationDatePipe,
    ],
    templateUrl: './task-notification.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskNotificationComponent {
    notification = input.required<UserNotificationEvent>();

    readonly expiration = computed(
        () => this.notification().task?.expiration?.zonedDatetime,
    );
}
